export const publicRoutes = [
  '/login',
  '/auth',
  '/callback',
  '/login/confirm',
  '/login/recover',
  '/login/accept-invitation',
  '/login/magic-link',
  '/error',
];

export const freeAccessRoutes = [
  ...publicRoutes,
  '/',
  '/overview',
  '/account',
  '/api-keys',
  '/forecast',
  '/market-aggregates',
  '/map',
];

// Routes that should bypass profile completion check (password reset, etc.)
export const profileCompletionExemptRoutes = [
  '/login/recover',
  '/login/accept-invitation',
  '/login/magic-link',
];

export interface RestrictedRoute {
  route: string;
  permission: string | null;
}

// List of restricted routes and their required permissions
export const restrictedRoutes: RestrictedRoute[] = [
  {
    route: '/live-benchmarking',
    permission: 'read:live_benchmarking',
  },
  {
    route: '/browse',
    permission: 'read:files',
  },
  {
    route: '/power',
    permission: 'read:power_forecast_v0',
  },
  {
    route: '/market-aggregates',
    permission: 'read:market_aggregates',
  },
];
